import React, {Component} from "react";
import axios from "axios";
import {createRoot} from "react-dom/client";
import Grid from "../components/Grid/Grid";
import AmbassadorHeader from "../components/AmbassadorHeader/AmbassadorHeader";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import AmbassadorHelper from "../utils/AmbassadorHelper";
import Common from "../utils/common";
import ConfigurationHelper from "../configuration/ClientConfigurationHelper";
import Analytics from "../libs/analytics";
import "../../sass/_document.scss";
import ThemeProviderWrapper from "../hoc/ThemeProviderWrapper";
import {Container} from "@mui/material";

export class AmbassadorPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasContent: true,
            checkFinish: false
        }
    }

    componentDidMount() {
        Common.setCustomCookie(TVSite?.ambassadorData);
    }

    fetchAssets = async ({ page, filters }) => {
        const { creator_id } = filters || {};

        let filter = '{attribute:{code: "show_on_storefront" , value: "yes"}}';
        if (creator_id) filter += `, {creator_id: ${creator_id}}`;

        const requestQuery = `{
            content(page: ${page}, per_page: 12, filter: {AND: [${filter}]}) {
                total
                items {
                    content_id
                    title
                    page_url
                    description
                    creator {
                        creator_id
                        employee_id
                        uri_stem
                        thumbnail
                        first_name
                        full_name
                        last_name
                        region {
                            name
                        }
                        store {
                            name
                            store_number
                        }
                    }
                    products {
                        product_id
                        image
                        price
                        sale_price
                        title
                        link
                    }
                    attributes {
                        code
                        value
                    }
                    content_type
                    creation_date
                    asset {
                        asset_type
                        video {
                            thumbnails {
                                width
                                height
                                url
                            }
                        }
                        photo {
                            thumbnails {
                                url
                                width
                                height
                            }
                        }
                    }
                }
            }
        }`;
        const apiUrl = ConfigurationHelper.getContentSearchUrl();
        const response = await axios.post(apiUrl, { query: requestQuery }, { withCredentials: true });
        this.setState({ hasContent: response.data.data.content.items.length > 0 });
        const items = response.data.data.content.items.map((item) => {
            const attribute = item.attributes?.find?.(
                (f) => f.code === "category"
            );
            const category = attribute?.value[0] || "";
            return {
                ...item,
                title: item.title,
                user_id: item?.creator?.creator_id,
                description: item.description,
                id: item.content_id,
                category: category,
                entityType: item.content_type === "video" ? 1 : 7,
                owner: item.creator,
            };
        });
        if (page === 1 && items.length > 0) {
            Analytics.pmEvent(items[0]);
        }
        return items;
    };

    render() {
        const {hasContent} = this.state;
        return <ThemeProviderWrapper>
            <Container>
                <Breadcrumbs className={"tvp-breadcrumbs-container"} keepOnMobile breadcrumbsList={[{
                    name: `${AmbassadorHelper.getDisplayName(TVSite.ambassadorData)}`,
                    url: "#",
                    active: true
                }]}/>
            </Container>
            <AmbassadorHeader hasContent={hasContent} ambassador={TVSite?.ambassadorData}/>
            <Grid
                fetchAssets={this.fetchAssets.bind(this)}
                filters={{ creator_id: TVSite?.ambassadorData?.id }}
                gridItemProps={{
                    maxDescriptionLines: 2,
                    redirect: true,
                    lazyLoadingThumbnails: true
                }}
                noResultsText="I haven’t posted any content yet, please check back soon."
            />
        </ThemeProviderWrapper>
    }
}

let root = null;
let isMounted = false;
const targetEl = document.getElementById("app-container");
function isAmbassadorRoute() {
    const subFolder = ConfigurationHelper.getGlobalConfiguration().sub_folder || '';
    const pathname = window.location.pathname.toLowerCase();
    // Ensure subFolder starts with / if present
    const prefix = subFolder ? (subFolder.startsWith('/') ? subFolder : '/' + subFolder) : '';
    // Allow rendering on localhost or site.<env>.tvpage.com (env = test|stage|app)
    const host = window.location.hostname;
    const envPattern = /^site\.(test|stage|app)\.tvpage\.com$/;
    const isAllowedHost = host === 'localhost' || envPattern.test(host);

    return pathname.startsWith(`${prefix}/a/`)  || isAllowedHost;
}

function mountAmbassadorApp() {
    if (!isMounted && isAmbassadorRoute()) {
        if (targetEl) {
            root = createRoot(targetEl);
            root.render(<AmbassadorPage/>);
            isMounted = true;
        }
    }
}

function unmountAmbassadorApp() {
    if (isMounted && root) {
        root.unmount();
        if (targetEl) targetEl.innerHTML = '';
        isMounted = false;
    }
}

function handleRouteChange() {
    if (isAmbassadorRoute()) {
        mountAmbassadorApp();
    } else {
        unmountAmbassadorApp();
    }
}

const _pushState = history.pushState;
history.pushState = function() {
    _pushState.apply(this, arguments);
    handleRouteChange();
};
const _replaceState = history.replaceState;
history.replaceState = function() {
    _replaceState.apply(this, arguments);
    handleRouteChange();
};

window.addEventListener('popstate', handleRouteChange);
window.addEventListener('hashchange', handleRouteChange);

// Initial mount if on ambassador route
if (isAmbassadorRoute()) {
    mountAmbassadorApp();
} else {
    unmountAmbassadorApp();
}
